// extracted by mini-css-extract-plugin
export default {"btnTop":"BackToTop_btnTop__MuEMp","show":"BackToTop_show__5tSNn","hide":"BackToTop_hide__rJOtR"};